// extracted by mini-css-extract-plugin
export default {"customButton":"buttons_customButton__OAjmd","iconWrapper":"buttons_iconWrapper__RAYkp"};